import React from 'react';
import { useTranslation } from 'react-i18next';
import { AVAILABLE_LANGUAGES, LANGUAGE_FLAGS, LANGUAGE_NAMES } from '../i18n';

/** Rozwijane menu wyboru języka. Wybór zapisuje się w localStorage (i18next caches). */
const LanguageSwitcher: React.FC<{ className?: string }> = ({ className }) => {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];

  const selected = AVAILABLE_LANGUAGES.includes(current) ? current : 'en';

  return (
    <select
      aria-label={t('common.language')}
      title={t('common.language')}
      value={selected}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      className={
        className ??
        'flex-shrink-0 w-28 max-w-[8rem] text-sm border border-gray-300 rounded-md px-2 py-1 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500'
      }
    >
      {AVAILABLE_LANGUAGES.map((code) => (
        <option key={code} value={code}>
          {(LANGUAGE_FLAGS[code] ? `${LANGUAGE_FLAGS[code]} ` : '') +
            (LANGUAGE_NAMES[code] || code)}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;
